// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ant-message-notice-content {\n  border-radius: 0.41667vw;\n}\n.ant-message-notice-content {\n  background: rgba(255,255,255,0) !important;\n  box-shadow: 0 0 0 #ccc;\n}\n.video-box {\n  width: 100%;\n}\n.video-box ._kwai-player-poster_uxc1a_19 {\n  background: none !important;\n}\n.video-box ._kwai-player-video_uxc1a_11 {\n  height: calc(100% - 3vw) !important;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
